import { ReactNode } from 'react';
import './styles.scss';

interface DrawerSectionProps {
  title: string;
  children: ReactNode;
}

export const DrawerCard = ({ title, children }: DrawerSectionProps): JSX.Element => {
  return (
    <div className="DrawerSection">
      <p className="title">{title}</p>
      {children}
    </div>
  );
};
